'use client';

import React, { useMemo } from 'react';
import AnnouncementBar, { Props as AnnouncementBarProps } from 'components/commercetools-ui/organisms/announcement-bar';
import { TasticProps } from 'frontastic/tastics/types';
import { DEFAULT_BAR_ID, useAnnouncementBarVisibility } from '../../../hooks/useAnnouncementBarVisibility';

const AnnouncementBarTastic = ({ data }: TasticProps<AnnouncementBarProps>) => {
  const announcementBarData = useMemo(() => [data], []);
  const { barVisibility, handleBarClose } = useAnnouncementBarVisibility(announcementBarData);

  const barId = data.barId ?? DEFAULT_BAR_ID;
  return (
    <AnnouncementBar
      {...data}
      visible={data.barId ? barVisibility[data.barId] : false}
      onClose={() => handleBarClose(barId)}
    />
  );
};

export default AnnouncementBarTastic;
